"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'reports.shared.title': 'Shared Conversations',
    'reports.shared.description': 'View conversations that have been shared with you by other users',
    'reports.shared.failedToLoad': 'Failed to load shared conversations',
    'reports.shared.retryButton': 'Try Again',
    'reports.shared.empty.title': 'No Shared Conversations',
    'reports.shared.empty.description': 'You don\'t have any conversations shared with you yet.',
    'reports.shared.createdAt': 'Created',
    'reports.shared.lastActivity': 'Last Activity',
    'reports.shared.model': 'AI Model',
    'reports.shared.unknownModel': 'Unknown Model',
    'reports.shared.unknownUser': 'Unknown User',
    'reports.shared.viewButton': 'View',
    'reports.shared.sharedWith': 'Shared with',
    'reports.shared.noUsers': 'No users',
};
